import { TouchTarget } from "@/components/clickable";
import { Spinner } from "@/components/layout";

export default function Content({ isLoading, children }) {
  return <TouchTarget>{isLoading ? <Spinner /> : children}</TouchTarget>;
}
